function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import Loader from 'react-loader-advanced';
import ConfigurationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/configuration-manager';
import ApiClient from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/api/api-client';
import TranslationManager from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager';
import { TranslationKeys } from '../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const';
import { loaderBackgroundStyle, loaderOpacity, spinner } from './views/Spinner';
var AccountManagementDefaultAccount = /*#__PURE__*/function (_React$Component) {
  function AccountManagementDefaultAccount(props) {
    var _this;
    _classCallCheck(this, AccountManagementDefaultAccount);
    _this = _callSuper(this, AccountManagementDefaultAccount, [props]);
    _this.translations = {
      accountManagemenlogintHeaderText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DEFAULT_LOGIN_ACCOUNT_HEADER),
      accountManagemenChooseloginText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DEFAULT_LOGIN_CHOOSE_LOGIN_TEXT),
      accountManagemenDefaultloginText: TranslationManager.getTranslation(TranslationKeys.ACCOUNT_MANAGEMENT_DEFAULT_LOGIN_HEADER)
    };
    _this.state = {
      isOpen: false,
      loadingData: false,
      accountsData: [],
      contactNo: '',
      defaultAccountNumber: '',
      defaultAccount: {},
      selectedAcct: {}
    };
    _this.toggle = _this.toggle.bind(_this);
    _this.cancelLogin = _this.cancelLogin.bind(_this);
    return _this;
  }
  _inherits(AccountManagementDefaultAccount, _React$Component);
  return _createClass(AccountManagementDefaultAccount, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAccountData();
    }
  }, {
    key: "getAccountData",
    value: function getAccountData() {
      var _this2 = this;
      this.setState({
        loadingData: true
      });
      ApiClient.userManagement.getDefaultAccountListData().then(function (accounts) {
        return _this2.setState({
          defaultAccountNumber: accounts
        });
      });
      var tokenDetails = ConfigurationManager.getTokenDetails();
      this.setState({
        contactNo: tokenDetails.contactNo
      });
      var loginAccountNo = tokenDetails.DefaultAccountId;
      ApiClient.userManagement.getAccountListData(loginAccountNo).then(function (accountList) {
        var accountsData = accountList.map(function (account) {
          var obj = {};
          obj.accountName = account.accountName;
          obj.accountNumber = account.accountNumber;
          obj.isDefault = account.accountNumber === _this2.state.defaultAccountNumber;
          return obj;
        });
        _this2.setState({
          accountsData: accountsData
        }, function () {
          return _this2.setDefaultAccount(), _this2.setState({
            loadingData: false
          });
        });
      }, function (error) {
        _this2.setState({
          loadingData: false
        });
      });
    }
  }, {
    key: "setDefaultAccount",
    value: function setDefaultAccount() {
      var _this3 = this;
      this.state.accountsData.map(function (elm) {
        if (elm.isDefault) {
          _this3.setState({
            defaultAccount: elm
          });
        }
      });
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
      this.getAccountData();
      this.setState({
        selectedAcct: this.state.defaultAccount
      });
    }
  }, {
    key: "cancelLogin",
    value: function cancelLogin() {
      this.setState({
        isOpen: false,
        selectedAcct: {},
        accountsData: []
      });
    }
  }, {
    key: "onDefaultSelected",
    value: function onDefaultSelected(acct) {
      var _this4 = this;
      this.setState(function (prevState) {
        return {
          accountsData: prevState.accountsData.map(function (el) {
            return el.accountNumber === acct.accountNumber ? _objectSpread(_objectSpread({}, el), {}, {
              isDefault: true
            }) : _objectSpread(_objectSpread({}, el), {}, {
              isDefault: false
            });
          })
        };
      }, function () {
        _this4.setAcct();
      });
    }
  }, {
    key: "setAcct",
    value: function setAcct() {
      var _this5 = this;
      this.state.accountsData.map(function (acct) {
        return acct.isDefault === true ? _this5.setState({
          selectedAcct: acct
        }) : acct;
      });
    }
  }, {
    key: "updateDefault",
    value: function updateDefault() {
      var _this6 = this;
      this.setState({
        isOpen: false,
        loadingData: true
      });
      ApiClient.userManagement.updateDefaultAccountData(this.state.contactNo, this.state.selectedAcct.accountNumber).then(function () {
        return _this6.getAccountData();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "acct-mng-default-login"
      }, /*#__PURE__*/React.createElement("p", null, this.translations.accountManagemenDefaultloginText), /*#__PURE__*/React.createElement("div", {
        className: "acct-mng-inner-div"
      }, /*#__PURE__*/React.createElement(Loader, {
        show: this.state.loadingData,
        message: spinner,
        contentBlur: loaderOpacity,
        backgroundStyle: loaderBackgroundStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-div"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-login"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "login-span"
      }, this.translations.accountManagemenlogintHeaderText), /*#__PURE__*/React.createElement("a", {
        className: "edit-link ".concat(this.state.isOpen ? 'hide' : ''),
        onClick: this.toggle
      }, "Edit")), !this.state.isOpen && /*#__PURE__*/React.createElement("p", {
        className: "default-login-acct"
      }, this.state.defaultAccount.accountNumber, " ", this.state.defaultAccount.accountName), this.state.isOpen && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "acct-header"
      }, this.translations.accountManagemenChooseloginText), this.state.accountsData.map(function (acct) {
        return /*#__PURE__*/React.createElement("p", {
          key: "default" + acct.accountNumber
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          id: "default-id" + acct.accountNumber,
          name: 'login-acct-names',
          value: acct.accountNumber,
          onClick: function onClick() {
            return _this7.onDefaultSelected(acct);
          },
          defaultChecked: acct.isDefault
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "default-id" + acct.accountNumber
        }, /*#__PURE__*/React.createElement("span", null, acct.accountNumber), /*#__PURE__*/React.createElement("span", {
          className: "acct-name"
        }, acct.accountName)));
      }), /*#__PURE__*/React.createElement("button", {
        className: "wdh-feature-b2b-button dark-bg",
        onClick: function onClick(e) {
          e.preventDefault();
          _this7.updateDefault(e);
        }
      }, "Update"), /*#__PURE__*/React.createElement("a", {
        onClick: this.cancelLogin
      }, "Cancel"))))));
    }
  }]);
}(React.Component);
export default AccountManagementDefaultAccount;